<template>
  <div class>
    <v-toolbar dark color="primary">
      <v-toolbar-title>
        <v-icon class="icon">fa-plus</v-icon>ADD Edify CONTENT
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-form>
           <v-switch
            v-model="improve.all_content"
              label="ALL CONTENT"
              color="primary" @change="toggleOnOff(improve.all_content)"
            ></v-switch>
            
            <v-select :error-messages="messages.no_of_users"
              v-model="improve.no_of_users"
              :items="partnerLevelList"
              item-text="name"
              item-value="id"
              label="# OF USERS"
              class="mt-4"
              dense
              v-on:change="changePrice(improve.no_of_users,improve)"
              attach
              
            ></v-select>
          
          
           <v-text-field :error-messages="messages.annual_price"
		          v-model="improve.annual_price"
              label="ANNUAL PRICE"
              type="text" readonly
            ></v-text-field>
            
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn color="primary" class="mr-1" @click="closePanel">Cancel</v-btn>
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="primary" @click="addImproveContent" :disabled="isActive">CONFIRM</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import improveAPI from "@/api/superadmin.js";
//import companyAPI from "@/api/company.js";

export default {
  name: "AddPartner",
 props: {
    id: {
      type: String,
      default: null
    },
    companyId: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      partner: {

      },
      improve:{},
      groups: [],
      messages: {},
      partnerLevelList: [
       {
          name: "1-20",
          id: 20
        },
        {
          name: "21-50",
          id: 50
        },
        
         {
          name: "51-100",
          id: 100
        },
        
         {
          name: "101-250",
          id: 250
        },
        {
          name: "250-500",
          id: 500
        },
        
      ],
      partnerCompanyList: [],
      isLevelTier2: false,
      successMessage: "Edify Content Successfully Added.",
      errorMessage:"Oops, something went wrong! Please check information is correct.",
      loading:false,
      isActive:true
    };
  },
  mounted() {
    //this.getPartnerDetails();
      this.getImproveContent(this.companyId);
  },
  methods: {
    closePanel() {
      this.$emit("closePanel", {});
      EventBus.$emit("USERS_UPDATED", this.params);
    },
    addImproveContent() {
     if(!this.improve.all_content) return;
      this.loading = true;
      improveAPI
        .createEdifyContent(this.id,this.companyId,this.improve)
        .then(() => {
          this.closePanel();
          EventBus.$emit("USERS_UPDATED", this.params);
          this.$snotify.success(this.successMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(err => {
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    getImproveContent(id) {
       improveAPI.getImproveContent(id+'?content_type=1').then(response => {
        this.improve = response.data.data;
        this.$store.dispatch("setDropzoneLoaded", true);
      });
    },
    changePrice(value,improve){
      let bindingList = {20:200,50:450,100:800,250:1500,500:200};
      this.improve.annual_price = bindingList[value];
      this.isActive = false;

      if(!improve.all_content) {
        this.isActive = true;
      } else if(value == 500){
        this.improve.annual_price = 'https://senso.cloud/gb/contact-us/';
        this.isActive = true;
      }
      //this.isActive = false;
      //if(this.improve!=''){
      //}
      
    },
    showCompanyList() {
      if(this.partner.partner_level==2) {
        this.isLevelTier2 = true
        this.partner.commission=15
      } else {
        this.isLevelTier2 = false;
        this.partner.commission=25
      }
    },
    getPartnerCompanyList() {
      partnerAPI.getPartnerByTier(1).then(response => {
        this.partnerCompanyList = response.data.data;
      });
    },
    toggleOnOff(all_content){
      this.isActive = true;

      if(this.improve.no_of_users && all_content){
        this.isActive = false;
      }
      if(this.improve.no_of_users==500){
        this.improve.annual_price = 'https://senso.cloud/gb/contact-us/';
        this.isActive = true;
      }
    }
  }
};
</script>
